module.exports = __webpack_public_path__ + "static/media/room-3.b960e750.jpg";